import { type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ComboboxBackdropProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

function ComboboxBackdrop({ className, ...props }: ComboboxBackdropProps) {
  return (
    <div
      className={twMerge(
        'bg-backdrop-subtle fixed inset-0 z-40 backdrop-blur-sm',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      {...props}
    />
  )
}

export { ComboboxBackdrop }
